
import { defineComponent, ref, computed, PropType } from "vue";
import { MdPerson, MdClose } from "@vicons/ionicons4";
import { PersonOutline } from "@vicons/ionicons5";
import { useMessage } from "naive-ui";
import { useStore } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/hosterEnums";
import inviteMemberModel from "@/core/models/hoster/inviteMember.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";

export default defineComponent({
  props: {
    type: Number,
  },
  components: {
    MdPerson,
    MdClose,
    PersonOutline,
  },
  setup() {
    const message = useMessage();
    const store = useStore();
    const valueRef = ref("");
    const checkBoxValueRef = ref(null);
    const person = computed<Array<invitePersonModel>>(
      () => store.getters[Module.desc + Getters.InvitMember]
    );
    const perosontag = new Array();
    function onDeletePerson(para: any) {
      store.dispatch(Module.desc + Actions.HandInivteMemberRemove, para);
    }
    function onPersonAttend() {
      // perosontag.forEach((item, index) => {
      //   if (item === para) perosontag.splice(index, 1);
      //   else perosontag.push(para)
      // })
      //console.log(perosontag);
      //alert('onPersonAttend');
    }

    return {
      onDeletePerson,
      onPersonAttend,
      handleUpdateShow(show: any) {
        //message.success(show)
      },
      person,
    };
  },
});
